import { SOCIAL_MEDIA_TYPES } from '../../../constants/admin/settings';
import { pick, filter, last, sortBy, uniqBy, uniq } from 'lodash';
import { ROLE_ARTIST_USER } from '../../../constants/authentication/permissions';
import { CONTRACT_TYPES } from '../../../constants/settings';
import { bufferArrayToUtf8 } from '../../../lib/string.utils';

// API / STATE SELECTORS
export const stateToApiData = data => {
    const bodyData = {
        ...data,
        socialMedia: filter(data.socialMedia, sm => sm.v),
        tags: uniq(data.tags)
    };

    bodyData.eventIds = uniqBy(bodyData.eventIds || []);
    bodyData.organizationIds = uniqBy(bodyData.organizationIds || []);
    return pick(bodyData, ['name', 'note', 'tags', 'website', 'socialMedia', 'image', 'eventIds', 'organizationIds']);
};

export const apiDataToState = data => {
    data.socialMedia = (data.socialMedia || []).concat([{ k: SOCIAL_MEDIA_TYPES[0], v: '' }]);
    data.image = bufferArrayToUtf8((data.image && data.image.data) || []);
    data.organizationIds = data.organizationIds || [];
    data.eventIds = data.eventIds || [];
    data.tags = (data.tags || []).map(x => x.text);
    data.note = data.note || '';
    return data;
};

export const getHighestLevelArtistUsers = (artistId, users, organizationId, eventId, noNone = false) => {
    const result = users.map(x => {
        const highestLevelRoleInThisEvent =
            last(
                sortBy(
                    filter(
                        x.roles,
                        r =>
                            r.artistId === artistId &&
                            r.orgId === organizationId &&
                            (!r.eventId || r.eventId === eventId)
                    ),
                    'level'
                )
            ) || {};
        return {
            id: x.id,
            fullName: x.fullName,
            email: x.email,
            type: highestLevelRoleInThisEvent.function || 'artist',
            permission: highestLevelRoleInThisEvent.name,
            roles: x.roles,
            accessToPerformanceContracts: !!highestLevelRoleInThisEvent.accessToPerformanceContracts,
            accessToClearanceContracts: !!highestLevelRoleInThisEvent.accessToClearanceContracts
        };
    });
    return noNone ? filter(result, r => !!r.permission) : result;
};

export function isArtistRole(role, artistId, orgId, eventId, contractType) {
    const accessToContractType =
        !contractType ||
        (contractType === CONTRACT_TYPES.CLEARANCE && role.accessToClearanceContracts) ||
        (contractType === CONTRACT_TYPES.PERFORMANCE && role.accessToPerformanceContracts);
    return (
        role.name === ROLE_ARTIST_USER &&
        role.orgId === orgId &&
        role.artistId === artistId &&
        (!role.eventId || role.eventId === eventId) &&
        accessToContractType
    );
}
